import { useState, useEffect } from 'react';
import { useGetLatestCompanyNotificationQuery, useUpdateStatusNotificationMutation } from 'services/auth';
import { NotificationWrapper, CloseButton, Icon } from './style';
import { useNavigate } from 'react-router-dom';
import { CloseIcon } from 'components/Icon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ResponsiveText from './ResponsiveText';

const NotificationBox = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [updateStatusNotification] = useUpdateStatusNotificationMutation();
  const user = useSelector(state => state.auth.user);
  const { data: latestNotification, refetch } = useGetLatestCompanyNotificationQuery(undefined, {
    skip: !user,
  });
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (latestNotification?.status_notification) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [latestNotification]);
  const handleNavigate = () => {
    if (latestNotification?.company_notification?.id) {
      updateStatusNotification(latestNotification.company_notification.id)
        .unwrap()
        .then(() => refetch())
        .catch((error) => console.error('Error updating status:', error));
    }
    navigate('/notification');
    setShowPopup(false);
  };

  return (
    showPopup && <NotificationWrapper show={showPopup} color='primary' onClick={handleNavigate} style={{ cursor: 'default' }}>
      <Icon>
        📩
      </Icon>
      <ResponsiveText text={t('common:notificationText')}></ResponsiveText>
      <CloseButton onClick={(e) => { e.stopPropagation(); setShowPopup(false); }}>
        <CloseIcon color="white" style={{ width: 12, height: 12 }} /> 
      </CloseButton>
    </NotificationWrapper>
  );
};

export default NotificationBox;

